import { graphql } from 'gatsby';
import React, { ReactElement, useEffect } from 'react';
import { Headline } from '../../../components';
import Meta from '../../meta';
import SupportTemplate from '../../templates/support';

interface IProps {
  data: any;
}

// The layout for an individual support post
export default function SupportPost({
  data: { strapiSupportPost },
}: IProps): ReactElement {
  const { title, subtitle, content } = strapiSupportPost;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const scriptTag = document.createElement('script');
      scriptTag.src = '/prism.js';

      document.body.appendChild(scriptTag);
    }
  }, []);

  return (
    <SupportTemplate>
      <Meta title={title}>
        <link rel="stylesheet" href="/prism.css" />
      </Meta>

      <article className="prose-lg md:prose-xl">
        <Headline level="2" className="mb-4">
          {title}
        </Headline>
        <p>{subtitle}</p>
        <hr />

        <div>
          <div
            dangerouslySetInnerHTML={{
              __html: content.data.content,
            }}
          />

          <p className="!mt-12">
            <a
              href="#"
              onClick={() => {
                window.history.back();
              }}>
              Go back to articles
            </a>
          </p>
        </div>
      </article>
    </SupportTemplate>
  );
}

export const pageQuery = graphql`
  query SupportPostQuery($id: String) {
    strapiSupportPost(id: { eq: $id }) {
      content {
        data {
          content
        }
      }
      title
      subtitle
      id
    }
  }
`;
